<div>
    <hr class="med-bottom-spacer">
    <section>
        <div id="subtitle-and-switch">
            <h2 id="subtitle">Create bundled standing authorization (optional)</h2>
            <as-switch
                [checkedLabel]="'Yes'" [uncheckedLabel]="'No'" 
                [checked]="checked" (change)="onChangeToggle($event)">
            </as-switch>
        </div>
        <span id="create-bundled-sa-messaging">{{bundledMessage}}</span>
    </section>
    <sdps-divider variation="secondary" class="sdps-m-vertical_medium"></sdps-divider>
</div>